import React from 'react';
import FitImage from 'src/components/10-atoms/image/FitImage';
import Column from 'src/components/10-atoms/layout/Column';
import AppAssets from 'src/constants/appAssets';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const QuestionSearchLoader = ({}) => {
    const [{ styles }] = useTheme(stylesGenerator);
    return (React.createElement(Column, { xAxis: "center", spacing: 12, style: styles.container },
        React.createElement(FitImage, { source: { uri: AppAssets.searching } })));
};
const stylesGenerator = createThemedStyle(() => ({
    container: {
        marginTop: 56,
    },
}));
export default React.memo(QuestionSearchLoader);
